import React, { useEffect, useState } from 'react';
// import { FaArrowUp } from 'react-icons/fa';
import './scrollTop.css';

const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisibility = () => {
    setVisible(window.scrollY > 200);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    visible && (
      <div className="scroll-to-top" onClick={scrollToTop}>
        {/* <FaArrowUp /> */}
        <i className="fa-solid fa-arrow-up"></i>
      </div>
    )
  );
};

export default ScrollToTopButton;
